import { Page } from 'pages/layout'

import { NeedsAttention } from './NeedsAttention'
import { Evaluate } from './Evaluate'
import { EvaluateV2 } from './EvaluateV2'
import { Tryouts } from './Tryouts'
import { useGateValue } from '@statsig/react-bindings'
import { FeatureGates } from 'lib/statsig/feature_gates'
import { AssignmentCallouts } from './AssignmentCallouts'

export function ReviewPage() {
  const shouldEnableLTA = useGateValue(FeatureGates.EnableLTA)
  const shouldEnableReviewEvaluateV2 = useGateValue(
    FeatureGates.EnableReviewEvaluateV2
  )

  return (
    <Page title="Review">
      {shouldEnableLTA ? <AssignmentCallouts /> : null}
      {!shouldEnableReviewEvaluateV2 ? <Tryouts /> : null}
      {shouldEnableReviewEvaluateV2 ? (
        <EvaluateV2 />
      ) : (
        <>
          <NeedsAttention />
          <Evaluate />
        </>
      )}
    </Page>
  )
}
